import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function Button({ className, variant = "default", size = "default", ...props }) {
  const base = "inline-flex items-center justify-center gap-2 rounded-xl text-sm font-bold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98]";
  
  const variants = {
    default: "bg-brand text-white shadow-sm shadow-brand/10 hover:bg-brand-light hover:shadow-md hover:shadow-brand/20",
    outline: "border border-border bg-transparent text-foreground hover:bg-muted/50 hover:border-brand/30 shadow-sm",
    ghost: "bg-transparent text-muted-foreground hover:bg-muted/70 hover:text-foreground",
    destructive: "bg-red-500 text-white shadow-sm shadow-red-500/10 hover:bg-red-600 hover:shadow-md dark:shadow-red-900/20",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
  };

  const sizes = {
    default: "h-10 px-5 py-2.5",
    sm: "h-9 px-3 text-xs rounded-lg",
    lg: "h-12 px-8 text-base",
    icon: "h-10 w-10 px-0",
  };

  return (
    <button 
      className={cn(base, variants[variant], sizes[size], className)} 
      {...props} 
    />
  );
}

